import React, { useState } from 'react';
import { AlertTriangleIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
import { StatusPill } from './ui/StatusPill';
import type { ComplianceFinding } from '../types/disclosures';
interface ComplianceReviewProps {
  findings: ComplianceFinding[];
}
export function ComplianceReview({
  findings
}: ComplianceReviewProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const hasFindings = findings.length > 0;
  return <section className="rounded-xl border border-slate-200 bg-white" data-id="element-17" data-mp="2r96n3obz17i">
      <div className="flex items-center justify-between gap-3 px-5 py-3.5" data-id="element-18" data-mp="3kwlym341p49e">
        <h3 className="text-[14px] font-semibold text-slate-900" data-id="element-19" data-mp="3kyoxzdr389qs">Compliance Review</h3>
        {hasFindings ? <div className="flex items-center gap-2" data-id="element-20" data-mp="3p00mth250qxx">
            <StatusPill tone="warning" data-id="element-21" data-mp="1j6k96b4vxska">
              <AlertTriangleIcon className="h-3 w-3" data-id="element-22" data-mp="1j3ek2vw9aqok" />
              {findings.length} Findings
            </StatusPill>
            <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-[12px] font-medium text-slate-600 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" data-id="element-23" data-mp="36qhewtlae4ys">
              {open ? 'Hide' : 'Review'}
              <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-24" data-mp="2nrd7fp9e8j98" />
            </button>
          </div> : <StatusPill tone="success" data-id="element-25" data-mp="2xpt19zzt26mf">
            <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-26" data-mp="2xqu9zxtcmh0z" />
            Passed
          </StatusPill>}
      </div>

      {hasFindings && open && <ul className="divide-y divide-slate-100 border-t border-slate-100" data-id="element-27" data-mp="czlg1xiq6q83">
          {findings.map(finding => <li key={finding.id} className="px-5 py-3.5" data-id="element-28" data-mp="81jyjh0y6yyq">
              <div className="flex items-start justify-between gap-3" data-id="element-29" data-mp="833e15es55zg">
                <div className="min-w-0" data-id="element-30" data-mp="f3fb80f3pxdc">
                  <p className="text-[11px] font-medium uppercase tracking-wide text-amber-700" data-id="element-31" data-mp="k2rz8ohplahi">
                    Compliance Finding
                  </p>
                  <p className="mt-0.5 text-[13px] font-medium text-slate-900" data-id="element-32" data-mp="p2o7izxfvo2v">{finding.title}</p>
                </div>
                <button type="button" onClick={() => setExpandedId(current => current === finding.id ? null : finding.id)} className="shrink-0 rounded-md px-2 py-1 text-[12px] font-medium text-blue-700 transition hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" data-id="element-33" data-mp="tz50c7fl2qma">
                  {expandedId === finding.id ? 'Hide Details' : 'View Details'}
                </button>
              </div>
              {expandedId === finding.id && <p className="mt-2 rounded-md bg-slate-50 px-3 py-2 text-[13px] leading-5 text-slate-600" data-id="element-34" data-mp="3epm45cfdpbwa">
                  {finding.detail}
                </p>}
            </li>)}
        </ul>}
    </section>;
}